/**
 * SEO記事の「贈り方」まわりの動き（2026-10）
 *
 *   ・贈り方ブロックの選択肢 → カルーセルへスクロールし、絞り込みを切り替える
 *   ・カルーセルの絞り込みチップ（LINEで贈れる／相手が選べる）
 *     「LINEで贈れる」は全件。オプション品以外はすべてeギフトに対応しているため、
 *     絞り込みではなく「全部これで贈れる」ことを示すラベルとして使う（修正指示 v3）
 *   ・章から一覧へ戻るリンク
 *   ・固定バー（SPのみ）の出し入れ
 *   ・計測イベント
 *
 * 計測について
 *   このストアに gtag も dataLayer も無い（2026-10 時点で確認）。
 *   GA4 は「Google & YouTube」アプリの Shopify ウェブピクセルとして入っており、
 *   サンドボックス内で動くためテーマのJSからは触れない。
 *   そこで、テーマの既存実装（quantity-switcher.liquid / bday-lp.js）と同じく
 *   Shopify.analytics.publish() でカスタムイベントを出す。
 *   GA4 へ届けるには、カスタムピクセル側で analytics.subscribe() して
 *   measurement protocol か gtag で送る設定が別途必要（柿山さんの作業）。
 *
 * リンクにUTMは付けない。同一ドメインでUTMを付けると、GA4上の流入元が
 * 検索から書き換わってしまうため。
 */
(function () {
  'use strict';

  function publish(name, payload) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload || {});
      }
    } catch (e) { /* 計測で画面を壊さない */ }
  }

  var list = document.querySelector('[data-eg-carousel]');
  if (!list) return;

  var articleHandle = list.getAttribute('data-article') || '';
  var items = Array.prototype.slice.call(list.querySelectorAll('.eg-carousel__item'));
  var chips = Array.prototype.slice.call(list.querySelectorAll('[data-eg-filter]'));
  // 初期状態は「LINEで贈れる」（全件。修正指示 v3 の1章）
  var current = 'line';

  /**
   * 絞り込みを当てる。filter は 'line'（全件）か 'choosable'。
   * アイテムのリンク先は記事内の章のままで、書き換えはしない
   * （修正指示 v3 の2章で v1 の挙動に戻した）。
   */
  function applyFilter(filter) {
    current = filter === 'choosable' ? 'choosable' : 'line';
    var shown = 0;
    items.forEach(function (li) {
      var isChoosable = li.getAttribute('data-choosable') === 'true';
      var show = current === 'line' || isChoosable;
      li.hidden = !show;
      if (show) shown += 1;
    });
    chips.forEach(function (c) {
      var on = c.getAttribute('data-eg-filter') === current;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    // 絞り込みを変えたら先頭に戻す（前の位置のまま空白が見えるのを防ぐ）
    var track = list.querySelector('.eg-carousel__track');
    if (track && typeof track.scrollTo === 'function') {
      track.scrollTo({ left: 0, behavior: 'auto' });
    }
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      applyFilter(c.getAttribute('data-eg-filter'));
    });
  });

  // ── 贈り方ブロックの選択肢
  Array.prototype.slice.call(document.querySelectorAll('[data-eg-okurikata]')).forEach(function (a) {
    a.addEventListener('click', function () {
      // 住所指定の案内には押せる要素が無いので、method は line / choosable の2値
      var method = a.getAttribute('data-eg-okurikata') === 'choosable' ? 'choosable' : 'line';
      publish('okurikata_select', {
        method: method,
        article: a.getAttribute('data-article') || articleHandle,
        intent: a.getAttribute('data-intent') || ''
      });
      applyFilter(method === 'choosable' ? 'choosable' : 'line');
      // href="#eg-list" によるスクロールはそのまま効かせる（JSで止めない）
    });
  });

  // ── カルーセルのアイテム
  Array.prototype.slice.call(list.querySelectorAll('[data-eg-carousel-link]')).forEach(function (a) {
    a.addEventListener('click', function () {
      publish('article_carousel_click', {
        product: a.getAttribute('data-product') || '',
        position: Number(a.getAttribute('data-position') || 0),
        filter: current,
        article: articleHandle
      });
    });
  });

  // ── 章内カードのボタン
  Array.prototype.slice.call(document.querySelectorAll('[data-eg-card-cta]')).forEach(function (a) {
    if (a.getAttribute('aria-hidden') === 'true') return; // 画像リンクは二重に数えない
    a.addEventListener('click', function () {
      var section = a.closest('.eg-ch');
      var pos = 0;
      if (section) {
        var all = Array.prototype.slice.call(document.querySelectorAll('.eg-ch'));
        pos = all.indexOf(section) + 1;
      }
      publish('article_card_cta', {
        product: a.getAttribute('data-product') || '',
        cta: a.getAttribute('data-eg-card-cta') || '',
        position: pos,
        article: a.getAttribute('data-article') || articleHandle
      });
    });
  });

  // ── 章から一覧への戻り道
  Array.prototype.slice.call(document.querySelectorAll('[data-eg-back-to-list]')).forEach(function (a) {
    a.addEventListener('click', function () {
      publish('article_back_to_list', {
        article: a.getAttribute('data-article') || articleHandle,
        from: a.getAttribute('data-from') || ''
      });
    });
  });

  // ── 記事末尾ブロック
  var endCta = document.querySelector('[data-eg-end-cta]');
  if (endCta) {
    endCta.addEventListener('click', function () {
      publish('article_end_cta', { article: endCta.getAttribute('data-article') || articleHandle });
    });
  }

  // ── 固定バー（SPのみ）
  var sticky = document.querySelector('[data-eg-sticky]');
  if (sticky) {
    Array.prototype.slice.call(sticky.querySelectorAll('[data-eg-sticky-btn]')).forEach(function (a) {
      a.addEventListener('click', function () {
        var target = a.getAttribute('data-eg-sticky-btn') === 'choosable' ? 'choosable' : 'all';
        // 固定バーの左は「すべて」のまま（カルーセルの絞り込みは line = 全件）
        publish('article_sticky_click', { target: target, article: articleHandle });
        applyFilter(target === 'choosable' ? 'choosable' : 'line');
      });
    });

    var isPhone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (isPhone && 'IntersectionObserver' in window) {
      // 贈り方ブロックが無い記事ではカルーセルを基準にする
      var gate = document.querySelector('[data-eg-okurikata-block]') || list;
      var footer = document.querySelector('.footer') || document.querySelector('footer');
      var passedGate = false;
      var footerVisible = false;

      function update() {
        var show = passedGate && !footerVisible;
        sticky.hidden = !show;
        document.body.classList.toggle('eg-has-sticky', show);
      }

      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // 要素の下端が画面より上に出たら「通過した」
          passedGate = e.boundingClientRect.bottom < 0;
        });
        update();
      }, { threshold: 0 }).observe(gate);

      if (footer) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { footerVisible = e.isIntersecting; });
          update();
        }, { threshold: 0 }).observe(footer);
      }

      window.addEventListener('scroll', function () {
        var r = gate.getBoundingClientRect();
        passedGate = r.bottom < 0;
        if (footer) {
          var fr = footer.getBoundingClientRect();
          footerVisible = fr.top < window.innerHeight;
        }
        update();
      }, { passive: true });
    }
  }
})();
